import { render, staticRenderFns } from "./my-video.vue?vue&type=template&id=67c3e6cb&scoped=true&"
import script from "./my-video.vue?vue&type=script&lang=js&"
export * from "./my-video.vue?vue&type=script&lang=js&"
import style0 from "./my-video.vue?vue&type=style&index=0&id=67c3e6cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3e6cb",
  null
  
)

export default component.exports